<h3 class="pr-10 text-[22px]/[30px] font-semibold">
  <slot />
</h3>